import {Params} from '@angular/router';

// import {PropsMapping} from '@shared/interfaces';
import {Model} from './model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'playerId',
  name: 'name',
  lastName: 'lastName',
  genre: 'genre',
  team: 'team',
  birthdate: 'birthdate',
  documentType: 'documentType',
  documentNumber: 'documentNumber',
  phone: 'phone',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',

  eventRank: 'eventRank',
};

export class PlayerModel extends Model {
  name!: string;
  lastName!: string;
  genre!: string;
  team!: string;
  birthdate!: Date;
  documentType!: string;
  documentNumber!: string;
  phone!: string;
  status!: string;
  createdAt!: Date;
  updatedAt!: Date;

  eventRank?: number;

  get fullName(): string {
    return `${this.lastName}, ${this.name}`.trim();
  }

  static getInstance(data: Params): PlayerModel {
    const model = new PlayerModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      (model as Params)[prop] = data[propsMapping[prop]];
    }
    return model;
  }

  // static search(
  //   apiService: ApiService,
  //   urlParams?: HttpParams
  // ): Observable<ListState<PlayerModel>> {
  //   return apiService
  //     .get('players', urlParams)
  //     .pipe(
  //       map((data: Params): ListState<PlayerModel> => {
  //         const list: PlayerModel[] = data['data'].map((item: Params): PlayerModel =>
  //           PlayerModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
